export class RandomIdGenerator {
    constructor() {
        this.chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
    }
    createRandomId() {
        let randomString = '';
        while (randomString.length < 16) {
            randomString += this.chars[Math.floor(this.chars.length * Math.random())];
        }
        return randomString;
    }
}
